import { usePointer, useRaf, useResize, useScroll, useKey, useLoad } from "../../services/index.js";
import { AbstractManager } from "./AbstractManager.js";
import { noop, isFunction, isDefined, isDev } from "../../utils/index.js";
const SERVICES_MAP = {
  scrolled: useScroll,
  resized: useResize,
  ticked: useRaf,
  moved: usePointer,
  keyed: useKey,
  loaded: useLoad
};
const SERVICE_NAMES = Object.keys(SERVICES_MAP);
class ServicesManager extends AbstractManager {
  __customServices = {};
  get __services() {
    return {
      ...this.__customServices,
      ...SERVICES_MAP
    };
  }
  has(service) {
    if (!((isFunction(this.__base[service]) || this.__base.__hasEvent(service)) && this.__services[service])) {
      return false;
    }
    const { has } = this.__services[service]();
    return has(this.__base.$id);
  }
  get(service) {
    return this.__services[service]().props();
  }
  enable(service) {
    if (this.has(service)) {
      return this.disable.bind(this, service);
    }
    if (!(isFunction(this.__base[service]) || this.__base.__hasEvent(service)) || !this.__services[service]) {
      return noop;
    }
    const serviceInstance = this.__services[service]();
    serviceInstance.add(this.__base.$id, (...args) => this.__base.__callMethod(service, ...args));
    return this.disable.bind(this, service);
  }
  enableAll() {
    return Object.keys(this.__services).map((serviceName) => this.enable(serviceName));
  }
  disableAll() {
    Object.keys(this.__services).forEach((serviceName) => {
      this.disable(serviceName);
    });
  }
  disable(service) {
    if (!this.__services[service]) {
      return;
    }
    const { remove } = this.__services[service]();
    remove(this.__base.$id);
  }
  toggle(service, force) {
    if (isDefined(force)) {
      if (force && !this.has(service)) {
        this.enable(service);
      }
      if (!force && this.has(service)) {
        this.disable(service);
      }
    } else if (this.has(service)) {
      this.disable(service);
    } else {
      this.enable(service);
    }
  }
  register(name, useFunction) {
    this.__customServices[name] = useFunction;
    this.__base.__addEmits(name);
  }
  unregister(name) {
    if (SERVICE_NAMES.includes(name)) {
      if (isDev) {
        throw new Error(`[ServicesManager] The \`${name}\` core service can not be unregistered.`);
      }
      return;
    }
    this.__base.__removeEmits(name);
    delete this.__customServices[name];
  }
}
export {
  ServicesManager
};
//# sourceMappingURL=ServicesManager.js.map
